import { createContext, useState } from 'react';

import OmeMeetOrgUnitEntryRosterPermissionsData from './OmeMeetOrgUnitEntryRosterPermissionsData';

export const OmeMeetOrgUnitEntryRosterPermissionsStateContext = createContext();

const OmeMeetOrgUnitEntryRosterPermissionsContextProvider = ({ children }) => {
  const stateHook = useState(OmeMeetOrgUnitEntryRosterPermissionsData.INITIAL_STATE);

  return (
    <OmeMeetOrgUnitEntryRosterPermissionsStateContext.Provider value={stateHook}>
      {children}
    </OmeMeetOrgUnitEntryRosterPermissionsStateContext.Provider>
  );
};

export default OmeMeetOrgUnitEntryRosterPermissionsContextProvider;